import CryptoJS from 'crypto-js';

export function aesEncryptHexByPass(content, pass) {
  const md5Hex = CryptoJS.MD5(pass).toString(CryptoJS.enc.Hex);

  const secretKey = CryptoJS.enc.Utf8.parse(md5Hex);

  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(content), // 明文转UTF-8字节数组（Java默认编码）
    secretKey,
    {
      mode: CryptoJS.mode.ECB, // Hutool AES默认ECB模式
      padding: CryptoJS.pad.Pkcs7, // 匹配Java PKCS5Padding（等价）
      iv: undefined, // ECB模式无IV，显式声明避免默认值干扰
    }
  );

  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}

/**
 * 忘记登录密码专用加密。
 * 明文为 `{密码}{timestamp}{account}`，勿用登录 getEncryPwd（只加密密码本身）。
 */
export function encryptForgetLoginPasswordAt(account: string, plainPassword: string, timestamp: number) {
  const username = String(account || '').trim();
  const packed = `${plainPassword}${timestamp}${username}`;
  return {
    timestamp,
    encrypted: aesEncryptHexByPass(packed, `${username}${timestamp}`),
  };
}

export function aesDecryptHexByPass(encryptedHex, pass) {
  const md5Hex = CryptoJS.MD5(pass).toString(CryptoJS.enc.Hex);
  const secretKey = CryptoJS.enc.Utf8.parse(md5Hex);
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Hex.parse(encryptedHex),
  });
  const decrypted = CryptoJS.AES.decrypt(cipherParams, secretKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
